import React from 'react';
import Footer from "../components/Footer";
import {Link} from "react-router-dom";

const Portfolio = ( { click, colors, projetos, dadosProjetos } ) => {

    return (
        <div>
            <div className="flex flex-col min-h-screen w-full sm:w-11/12 lg:w-4/5 mx-auto">
                <div id='flex-container' className={`items-center flex flex-row flex-wrap justify-center pt-32 sm:pt-40 lg:pt-48 xl:pt-52 text-4xl sm:text-6xl md:text-7xl xl:text-8xl w-full`}>
                    <div className={`font-sans ${colors["text"]} px-1`}>
                        NOSSOS <span className='font-bold'>PROJETOS</span>
                    </div>
                </div>
                <div className="container mx-auto py-10 sm:py-20 w-full px-3 sm:px-0">
                    <div className="grid grid-cols-3 gap-2 sm:gap-4 justify-items-center">
                        {projetos.map((name) => {
                            const info = dadosProjetos[name];
                            return (
                                <Link key={name} to={"/portfolio/" + name} className="relative group overflow-hidden">
                                    <img src={"/resources/imgs/portfolio/projetos/" + name + "/card.png"} alt={name} className="w-full h-full object-cover"/>
                                    {/* Overlay de Texto */}
                                    <div className="absolute bottom-0 left-0 w-full p-2 sm:p-4 bg-gradient-to-t from-black/40 to-transparent">
                                        <div className="text-white font-sans leading-tight">
                                            <div className="text-xs sm:text-lg md:text-xl lg:text-3xl uppercase">
                                                {info?.beginName} <span className="font-bold">{info?.endName}</span>
                                            </div>
                                            {info?.year && (
                                                <div className="text-[10px] sm:text-sm md:text-md lg:text-2xl opacity-90">
                                                    {info.year}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </Link>
                            );
                        })}
                    </div>
                </div>
            </div>
            <Footer colors={colors}/>
        </div>
    );
};

export default Portfolio;